
export function tryArrayConcat<T>(arr: T[] | unknown, source: T[]): Undefinable<T[]> {
    if (Array.isArray(arr)) {
        return arr.concat(source);
    }
}
